import EventBus from "@packages/event-bus";
import Sortable from "sortablejs";

export default {
    data() {
        return {
            itemKeys: new WeakMap(),
            currentItemKey: 0,
            orderParams: {},
        };
    },

    methods: {
        async dragReorder({ oldIndex, newIndex, item }) {
            const movedItem = this.list.splice(oldIndex, 1)[0];
            this.list.splice(newIndex, 0, movedItem);

            if (!this.entity) throw new Error("Entity not specified");

            if (!item.id) throw new Error("Item must have an ID");
            await this.$api[this.entity][this.orderMethod]({
                id: item.id,
                order: newIndex + 1,
                ...this.orderParams
            });

            EventBus.$emit("show-message", {
                type: "SUCCESS",
                message: "Ordem salva",
                timeout: 2000
            });

            await this.load();
        },

        itemKey(item) {
            if (!this.itemKeys.has(item))
                this.itemKeys.set(item, ++this.currentItemKey);

            return this.itemKeys.get(item);
        }
    },

    mounted() {
        const tableBody = this.$refs.table.$el.getElementsByTagName("tbody")[0];

        new Sortable(tableBody, {
            draggable: ".sortable-row",
            handle: ".sort-handle",
            onEnd: this.dragReorder
        });
    }
};
